import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { CHART_COLORS, formatCurrency } from "../constants";

interface RevenueTrendChartProps {
  data: any[];
  loading: boolean;
}

const RevenueTrendChart = ({ data, loading }: RevenueTrendChartProps) => {
  if (loading) {
    return (
      <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="30%" height={24} />
          <Skeleton width="100%" height={280} sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Revenue Trend
        </Typography>
        {data && data.length > 0 ? (
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <defs>
                <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={CHART_COLORS.primary} stopOpacity={0.3} />
                  <stop offset="95%" stopColor={CHART_COLORS.primary} stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 11 }}
                tickFormatter={(val) => {
                  const d = new Date(val);
                  return `${d.getDate()}/${d.getMonth() + 1}`;
                }}
              />
              <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `€${v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v}`} />
              <Tooltip
                formatter={(value: any) => [formatCurrency(value), "Revenue"]}
                labelFormatter={(label) => new Date(label).toLocaleDateString()}
                contentStyle={{ borderRadius: 8, fontSize: 13 }}
              />
              <Area
                type="monotone"
                dataKey="revenue"
                stroke={CHART_COLORS.primary}
                strokeWidth={2.5}
                fill="url(#revenueGradient)"
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ height: 280, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography color="text.secondary">No revenue data for selected period</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default RevenueTrendChart;
